"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const utilities_1 = __importStar(require("jsAssets/utilities"));
const useStageTriggerTypes = () => {
    const [stageTriggerTypeOptions, setStageTriggerTypeOptions] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const fetchStageTriggerTypeOptions = async () => {
        setIsLoading(true);
        try {
            const response = await fetch('/v2/api/stage-trigger-types');
            if (!response.ok)
                throw new Error('Unable to get stage trigger type options');
            const data = await response.json();
            const stageTriggerTypeOptionFormat = (0, utilities_1.parseJsonApi)(data);
            const formatedOptions = stageTriggerTypeOptionFormat
                .map((option) => ({
                label: option === null || option === void 0 ? void 0 : option.label,
                value: option === null || option === void 0 ? void 0 : option.id,
            }))
                .filter((option) => option.value > 2);
            setStageTriggerTypeOptions(formatedOptions);
        }
        catch (err) {
            utilities_1.default.notification.danger(err || 'Failed to load stage trigger type options');
        }
        finally {
            setIsLoading(false);
        }
    };
    (0, react_1.useEffect)(() => {
        fetchStageTriggerTypeOptions();
    }, []);
    return { stageTriggerTypeOptions, isLoading };
};
exports.default = useStageTriggerTypes;
